import React, { useEffect } from "react";
import useMobile from "../../../hooks/useMobile";
import Particles from "../../../components/AuroraBackground/Particles";
import Ribbons from "../../../components/RibbonsEffect/Ribbons";
import AnimatedContent from "../../../components/AnimatedContent/AnimatedContent";
import LogoTextFlama from "../../../assets/logo-text-flama";

import "./HomeHero.css";

// Path del flamaClip
const flamaPath =
  "M238.928 749.906C225.53 716.542 226.348 689.93 228.062 675.504C231.833 643.696 246.048 619.379 260.659 594.402C278.882 563.254 286.082 561.961 294.099 542.576C305.888 514.065 304.016 483.656 296.605 455.619C302.407 458.864 324.718 472.183 335.056 500.773C346.001 530.998 335.821 556.871 333.395 562.647C368.101 535.983 385.877 506.733 394.421 489.906C401.885 475.189 426.174 427.372 411.986 382.061C408.979 372.434 402.122 350.517 382.738 341.945C377.49 339.624 372.637 338.86 369.367 338.596C374.141 335.194 388.329 326.068 408.663 326.068C428.996 326.068 443.185 335.22 447.958 338.596C447.088 297.9 457.004 270.286 466.34 252.483C479.421 227.586 490.128 224.262 507.297 188.947C523.252 156.111 524.861 136.62 524.017 122.905C523.226 109.692 520.008 99.0362 517.318 91.9679C527.999 96.0559 535.225 101.647 539.893 106.184C570.011 135.539 558.592 184.41 557.458 188.947C571.277 181.457 593.193 166.977 610.968 141.288C637.393 103.098 639.029 62.7186 637.71 41.8036C636.602 24.1327 632.699 9.78494 629.35 0C413.805 0.949482 198.314 1.87259 -17.1781 2.82207C-15.9122 251.718 -14.62 500.614 -13.3541 749.51C-15.5694 810.304 -17.7847 871.071 -20 931.864C21.7744 938.299 39.998 929.174 48.8592 919.204C63.839 902.351 51.1273 883.994 66.4235 849.76C79.9527 819.456 94.7742 822.937 104.98 795.481C116.136 765.441 102.238 750.882 107.829 719.786C111.284 700.507 122.413 673.974 157.805 645.516C137.999 689.535 151.871 734.899 180.96 750.539C205.381 763.7 233.574 752.174 238.901 749.88Z";

// ID único para este clip-path
const clipPathId = "flamaClip";

function HomeHero() {
  const isMobile = useMobile();

  useEffect(() => {
    // Verificamos si ya existe el clipPath global
    if (!document.getElementById(clipPathId)) {
      // Creamos el elemento SVG usando namespace
      const svgNS = "http://www.w3.org/2000/svg";
      const svg = document.createElementNS(svgNS, "svg");
      svg.setAttribute("class", "clip-svg-global");
      svg.setAttribute("id", "global-clip-svg");
      svg.style.position = "absolute";
      svg.style.width = "0";
      svg.style.height = "0";
      svg.style.zIndex = "-9999";
      svg.style.pointerEvents = "none";

      // Creamos los elementos internos del SVG
      const defs = document.createElementNS(svgNS, "defs");
      const clipPath = document.createElementNS(svgNS, "clipPath");
      clipPath.setAttribute("id", clipPathId);

      const path = document.createElementNS(svgNS, "path");
      path.setAttribute("d", flamaPath);

      // Construimos la estructura del SVG
      clipPath.appendChild(path);
      defs.appendChild(clipPath);
      svg.appendChild(defs);

      // Añadimos el SVG al body para que sea global
      document.body.appendChild(svg);

      console.log("Clip path global creado:", clipPathId);
    } else {
      console.log("Clip path global ya existe:", clipPathId);
    }
  }, []);

  return (
    <section className="home-hero">
      <Particles particleColors={["#7dce85", "#44a34c", "#5abd63"]} />

      {/* Eliminamos el SVG local ya que ahora usamos el global */}

      <div className="hero-background">
        <Ribbons
          baseThickness={20}
          colors={["#FF4D4D", "#FF8C00"]}
          speedMultiplier={0.5}
          maxAge={500}
          enableFade={false}
          enableShaderEffect={true}
        />
      </div>
      <div className="hero-content">
        <div className="hero-logo">
          <LogoTextFlama
            width={isMobile ? 300 : 700}
            height={isMobile ? 80 : 170}
            fillColor={"#5ABD63"}
          />
        </div>
        <h2 className="hero-subtitle">CASAL POPULAR DE CERDANYOLA</h2>
        <div className="hero-description">
          <AnimatedContent delay={1000}>
            <p>
              Benvinguts al Casal Popular La Flama, l'espai autogestionat del
              moviment popular de Cerdanyola.
              <br></br>
              <br></br>
              <i>
                Cultura no solament ho és l'art, o els llibres, sinó totes les
                formes de manifestació d'una comunitat. Cultura és la mateixa
                manera de viure que té un poble.
              </i>
              <br></br>
              <span style={{ float: "right" }}>Manuel de Pedrolo</span>
            </p>
          </AnimatedContent>
        </div>
      </div>
      <div className="hero-participa">
        <a
          href="https://docs.google.com/forms/d/e/1FAIpQLSeg7f_ucxeBr9YbUrrAQc7H4bbBhs7en6BCPT4GKwb2mzGjwg/viewform"
          target="_blank"
          rel="noreferrer"
        >
          PARTICIPA
        </a>
      </div>
    </section>
  );
}

export default HomeHero;
